import { compartir } from '../movil/compartir';
import { analytics, ANALYTICS_EVENTS } from '../services/analytics';

// Channel notes for backend/integration:
//   - native: menú de compartir (navigator.share en la web, el del sistema en la app) — user cancellation silently ignored
//   - twitter: URL passed as separate param so Twitter's intent API handles encoding; messageText has URL stripped
//   - linkedin: no pre-fill supported by LinkedIn's API — user must paste message manually
//   - All channels track REFERRAL_LINK_SHARED with channel name for analytics
const useReferralShare = (url: string, messageText: string) => {
	const shareNative = async () => {
		if (!url) return;
		try {
			await compartir({ title: 'Échale un ojo a Arca', text: messageText, url });
			analytics.track(ANALYTICS_EVENTS.REFERRAL_LINK_SHARED, { channel: 'native_share' });
		} catch {
			// usuario canceló — ignorar
		}
	};

	const shareWhatsApp = () => {
		if (!url) return;
		window.open(`https://wa.me/?text=${encodeURIComponent(messageText)}`, '_blank');
		analytics.track(ANALYTICS_EVENTS.REFERRAL_LINK_SHARED, { channel: 'whatsapp' });
	};

	const shareGmail = () => {
		if (!url) return;
		window.open(
			`https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent('Te invito a Arca')}&body=${encodeURIComponent(messageText)}`,
			'_blank'
		);
		analytics.track(ANALYTICS_EVENTS.REFERRAL_LINK_SHARED, { channel: 'gmail' });
	};

	const shareEmail = () => {
		if (!url) return;
		window.location.href = `mailto:?subject=${encodeURIComponent('Te invito a Arca')}&body=${encodeURIComponent(messageText)}`;
		analytics.track(ANALYTICS_EVENTS.REFERRAL_LINK_SHARED, { channel: 'email' });
	};

	const shareTwitter = () => {
		if (!url) return;
		const textWithoutUrl = messageText.replace(url, '').trim();
		window.open(
			`https://twitter.com/intent/tweet?text=${encodeURIComponent(textWithoutUrl)}&url=${encodeURIComponent(url)}`,
			'_blank'
		);
		analytics.track(ANALYTICS_EVENTS.REFERRAL_LINK_SHARED, { channel: 'twitter' });
	};

	const shareLinkedIn = () => {
		if (!url) return;
		window.open(
			`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
			'_blank'
		);
		analytics.track(ANALYTICS_EVENTS.REFERRAL_LINK_SHARED, { channel: 'linkedin' });
	};

	const shareFacebook = () => {
		if (!url) return;
		window.open(
			`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
			'_blank'
		);
		analytics.track(ANALYTICS_EVENTS.REFERRAL_LINK_SHARED, { channel: 'facebook' });
	};

	return {
		shareNative,
		shareWhatsApp,
		shareGmail,
		shareEmail,
		shareTwitter,
		shareLinkedIn,
		shareFacebook
	};
};

export default useReferralShare;
